import { Controller, useFieldArray, useForm } from 'react-hook-form';
import { FaExclamationCircle } from 'react-icons/fa';
import { showsExtendedPackageFields } from '../../data/acOrderRules';
import InputComponent from '../../components/InputComponent';
import TextareaComponent from '../../components/TextareaComponent';

// SCSS
import '../../assets/scss/sectionSeven.scss';

const SectionSeven = ({
	control,
	register,
	formData,
	sending,
	submitStatus,
	autosaveUi,
}) => {
	const { fields, append, remove } = useFieldArray({
		control,
		name: 'websites',
	});

	return (
		<div className='sectionSeven'>
			<div className='header'>
				<h2>Ekstra informasjon</h2>
				<div className='border'></div>
				<small className='field-description-text'>
					Legg til ekstra informasjon om kampanjeperioden, private
					profiler og bannerannonsering
				</small>
			</div>

			<div className='flex-row'>
				<div className='flex-col'>
					<TextareaComponent
						label='Ønsker om kampanjeperiode og annen info'
						name='kampanjeperiode'
						className='kampanjeperiode'
						placeholder='Skriv inn ønske om kampanjeperiode'
						cols='40'
						rows='4'
						register={register}
					/>
					<small className='field-description-text'>
						Spesielle ønsker om kampanjeperiode? <br />
						(Oppstart er normalt 2 virkedager fra bestilling, før kl
						09:00)
						<FaExclamationCircle size='22' />
					</small>
				</div>
				{showsExtendedPackageFields(formData.packageChoice) && (
					<div className='flex-col'>
						<TextareaComponent
							label='Innlegg til story private profiler'
							name='storyText'
							className='story-text'
							placeholder='Skriv tekst til innlegg for story til private profiler i SOME'
							cols='40'
							rows='4'
							register={register}
						/>
						<small className='field-description-text'>
							Konsulenter i AC kan velge å legge utvalgte stillinger
							på egne storier på facebook og insta, og da må dette
							sendes over fra Polaris media. <br />
							Skriv her dersom slikt innlegg ønskes.
							<FaExclamationCircle size='22' />
						</small>
					</div>
				)}
				{/* <div className='flex-col'>
					<TextareaComponent
						label='Bannerannonsering'
						name='bannerannonsering'
						className='bannerannonsering'
						placeholder='Skriv inn tekst til bannerannonsering'
						cols='40'
						rows='4'
						register={register}
						counter={false}
					/>

					<small className='field-description-text'>
						Tekst ved bannerannonsering. I de største formatene har
						vi plass til en kort setning i tillegg til "Vi søker ...
						". <br />
						Eksempel "til sin avdeling på hamar" eller "bli med på
						en unik reise!". Dersom det er lang stillingstittel
						og/eller det designmessig ikke vil se bra ut, vil dette
						falle bort.
						<FaExclamationCircle size='22' />
					</small>
				</div> */}
			</div>

			<div className='submit-area'>
				{autosaveUi && !sending ? (
					<p className='draft-save-status' aria-live='polite'>
						{autosaveUi}
					</p>
				) : null}
				{sending ? (
					<div
						className='submit-progress'
						role='status'
						aria-live='polite'
					>
						<div className='submit-progress__bar' aria-hidden='true'>
							<span />
						</div>
						<p className='submit-progress__text'>{submitStatus}</p>
						<p className='submit-progress__hint'>
							Dette kan ta litt tid. Ikke lukk siden.
						</p>
					</div>
				) : null}
				<input
					type='submit'
					value={sending ? 'Sender…' : 'Send bestilling'}
					disabled={sending}
				/>
			</div>
		</div>
	);
};

export default SectionSeven;
